import { connect } from 'react-redux';
import {
  getSecondaryImages,
  signImage,
  cleanImage,
  cleanSecondaryImage,
  cleanSecondaryImages,
  getLabelImage,
  getMetadataDescription,
  getPromotionalImage
} from 'core/slices/images';
import { getConsolidationStages } from 'core/slices/consolidation';
import {
  getImagesList,
  getImagesSession,
  getImageUrl,
  getConsolidationStagesList,
  isLoadingConsolidationStages,
  getLabelImageUrl,
  isLoadingLabelImageUrl,
  getMetadataDescriptionList,
  getPromotionalImageUrl,
  isLoadingPromotionalImageUrl
} from 'core/selectors';
import Visualizer from '../../../components/visualizer/Visualizer';

export default connect(
  state => ({
    images: getImagesList(state),
    imagesSession: getImagesSession(state),
    image_url: getImageUrl(state),
    consolidationStages: getConsolidationStagesList(state),
    isLoadingConsolidationStages: isLoadingConsolidationStages(state),
    labelImage: getLabelImageUrl(state),
    isLoadingLabelImage: isLoadingLabelImageUrl(state),
    metadataDescription: getMetadataDescriptionList(state),
    promotionalImage: getPromotionalImageUrl(state),
    isLoadingPromotionalImage: isLoadingPromotionalImageUrl(state),
  }),
  {
    getSecondaryImages,
    signImage,
    cleanImage,
    cleanSecondaryImage,
    cleanSecondaryImages,
    getConsolidationStages,
    getLabelImage,
    getPromotionalImage,
    getMetadataDescription,
  },
)(Visualizer);
